// Defined in general.js
/* global createCookie */

import Html5Entities from '../../external/npm/html5-entities.js';
import { getEmptyLocationParams, getLocationText } from '../common/locationUtils.js';
import { getURLParam } from '../adapters/dupes/queryParams.js';

const crumbsToSkip = {
    sortBy: true,
    centerLat: true,
    centerLng: true,
    landing: true,
};

function buildTeachersOrSchoolsOnlyBreadcrumb(searchURL) {
    const teachersOnly = getURLParam(searchURL, 'teachersOnly');
    const schoolsOnly = getURLParam(searchURL, 'schoolsOnly');
    if (teachersOnly || schoolsOnly) {
        let text = teachersOnly ? 'Teachers named ' : 'Schools named ';
        text += '"' + getURLParam(searchURL, 'keywords') + '"';
        const key = teachersOnly ? 'teachersOnly' : 'schoolsOnly';
        return [[key, null, text]];
    }
}

/**
 * Returns a list of breadcrumb data, with the crumb name and params to remove when it's clicked
 * @param {string[][]} searchBreadcrumb The breadcrumb returned from our API
 * @param {string} searchURL The current search URL
 */
export function extractBreadcrumbs(searchBreadcrumb, searchURL) {
    const crumbs = [];
    const breadcrumb = buildTeachersOrSchoolsOnlyBreadcrumb(searchURL) || searchBreadcrumb || [];

    for (let i = 0; i < breadcrumb.length; i++) {
        const crumb = breadcrumb[i];
        const crumbKey = crumb[0];
        const crumbValue = crumb[1];
        const crumbName = crumb[2];

        if (crumbsToSkip[crumbKey]) continue;

        // eslint-disable-next-line eqeqeq
        if (crumbName == '') continue;

        let actualCrumbName = crumbName;

        let removeParams = {
            remove: true,
        };
        removeParams[crumbKey] = crumbValue;

        if (crumbKey === 'keywords') {
            removeParams.widenRetry = null;
        } else if (crumbKey === 'locationName') {
            removeParams = getEmptyLocationParams();
        } else if (crumbKey === 'state') {
            removeParams = getEmptyLocationParams();

            const locationText = getLocationText(searchURL);
            if (locationText !== crumbValue) {
                actualCrumbName = locationText;
            }
        }

        actualCrumbName = Html5Entities.decode(actualCrumbName);

        crumbs.push({
            crumbName: actualCrumbName,
            removeParams: removeParams,
        });
    }
    return crumbs;
}

/**
 * Sets the page title and a matching cookie based on the search breadcrumbs
 * @param {object} breadcrumb The project data from our API
 * @param {string} searchURL The current search URL
 */
export function setPageTitle(breadcrumb, searchURL) {
    // This function won't exist on the server side
    if (typeof createCookie !== 'function') return;

    const crumbData = extractBreadcrumbs(breadcrumb, searchURL);
    const searchDescString = crumbData.map(data => data.crumbName).join(' + ');

    if (searchDescString !== '') {
        // TODO: is "requests" good here, or do we need smart projects/essentials langauge?
        document.title = searchDescString.replace(/ &amp; /g, ' & ').replace(/&#034;/g, '"') +
            ' requests | DonorsChoose';
    } else {
        document.title = 'Find a classroom to support | DonorsChoose';
    }
    createCookie('searchTermsURL', searchURL, 1);
    createCookie('searchTermsDesc', window.b64EncodeUnicode(document.title), 1);
}
